"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEGACY_PAYMENT_CONFIGS = exports.SELECTABLE_PAYMENT_CONFIGS = exports.PAYMENT_DEVICE_CONFIGS = exports.EMV_DEVICE_MODELS = exports.DEJAVOO_CLOUD_MODEL = void 0;
exports.getModelDef = getModelDef;
exports.getPaymentConfig = getPaymentConfig;
exports.resolvePaymentConfig = resolvePaymentConfig;
exports.paymentConfigOptionsFor = paymentConfigOptionsFor;
const rubytillPay_1 = require("../../../rubytillPay");
const cloud = (model) => ({
    model, deviceClass: 'cloud', connectionType: 'cloud',
    creditMethod: 'credit_nmi_cloud', emvMode: 'cloud',
});
/** The virtual "Dejavoo Cloud POS" processor model — TPN-only, no pairing. */
exports.DEJAVOO_CLOUD_MODEL = 'Dejavoo Cloud POS';
exports.EMV_DEVICE_MODELS = [
    cloud('Ingenico E-7000'),
    cloud('Ingenico Lane 3000'),
    cloud('Ingenico Lane 5000'),
    cloud('Ingenico Lane 7000'),
    cloud('Ingenico Lane 8000'),
    cloud('PAX A920'),
    cloud('PAX A80'),
    cloud('Dejavoo QD4'),
    {
        model: 'ID TECH VP3350',
        deviceClass: 'nmi_direct_vp3350',
        connectionType: 'bluetooth',
        creditMethod: 'credit_nmi_direct',
        emvMode: 'sdk',
    },
    {
        // Dejavoo P17 wired to the K10 over USB (SPIn USB / pure USB mode) through a
        // P1/P18 master base. Synchronous serial result — recorded like the VP3350 direct path.
        model: 'Dejavoo P17',
        deviceClass: 'dejavoo_spin_usb',
        connectionType: 'usb',
        creditMethod: 'credit_dejavoo',
        emvMode: 'usb',
    },
    {
        // Cloud Dejavoo processor — a TPN only, no physical device. Registered to a
        // home location and referenced (cross-location) by online_sales terminals to
        // charge the storefront through iPOS Transact / Hosted Payment Page.
        model: exports.DEJAVOO_CLOUD_MODEL,
        deviceClass: 'dejavoo_cloud',
        connectionType: 'cloud',
        creditMethod: 'credit_dejavoo',
        emvMode: 'cloud',
    },
    {
        // Android Tap to Pay — the RubyTill Pay route on a plain Android device,
        // card read by Dejavoo's Tap to Pay SDK (NFC) instead of DvPayLite. Same
        // device class / tender / emvMode as the P-series RubyTill Pay app.
        model: rubytillPay_1.ANDROID_TAP_TO_PAY_MODEL,
        deviceClass: 'dejavoo_rubytill_pay',
        connectionType: 'cloud',
        creditMethod: 'credit_dejavoo_rtpay',
        emvMode: 'rtpay',
    },
];
function getModelDef(model) {
    if (!model)
        return undefined;
    return exports.EMV_DEVICE_MODELS.find(m => m.model === model);
}
exports.PAYMENT_DEVICE_CONFIGS = [
    {
        /* LABELS LEAD WITH THE DIFFERENCE. Dejavoo has three configs and two of
           them are cloud; "Dejavoo Cloud POS" and "Dejavoo — SPIn Cloud" read as
           near-synonyms while meaning opposite things — a terminal a customer taps
           versus a TPN with no device at all. Picking wrong gives a device that can
           never take a card in person. The IDS are untouched: they are written on
           every stored emv-device row and carried into reporting as
           `gateway#<id>`, so renaming one would be a data migration. */
        id: 'dejavoo_spin_usb',
        label: 'Dejavoo P Series — USB',
        hint: 'Wired to the till over USB through a P1/P18 base. USB mode issues no Register Id or Auth Key — the serial and the iPOS Transact TPN are the whole registration, and the TPN is what refunds are credited through.',
        orderUi: true,
        profile: {
            deviceClass: 'dejavoo_spin_usb',
            connectionType: 'usb',
            creditMethod: 'credit_dejavoo',
            emvMode: 'usb',
        },
    },
    {
        /*
          THE SAME TERMINAL, REACHED WITHOUT A CABLE.
    
          `dejavoo_spin_usb` and this are one physical device and one set of
          credentials; only the route differs. That is why the registration form is
          identical for both — SPIn addresses the terminal by RegisterId (or TPN)
          with AuthKey authorizing, over the wire or over the cloud alike.
    
          It is a separate id rather than a flag because PAYMENT_DEVICE_CONFIGS ids
          ARE the stored `deviceClass` strings, keyed into pos-payments routing and
          carried into reporting. A flag beside the id would be a second answer to
          a question this list already answers.
        */
        id: 'dejavoo_spin_cloud',
        label: 'Dejavoo P Series — SPIn Cloud',
        hint: 'The same terminal, reached over Dejavoo’s cloud instead of a cable. Needs the Register Id and Auth Key that SPIn Mode = Cloud issues, plus the iPOS Transact TPN.',
        orderUi: true,
        profile: {
            deviceClass: 'dejavoo_spin_cloud',
            connectionType: 'cloud',
            /* NOT `cloud`. That value already means NMI Cloud on a register's
               hardwareConfig, and collapsing the two would route a Dejavoo sale
               through NMI. */
            emvMode: 'spin_cloud',
            /* Its OWN tender, not `credit_dejavoo`. That one means SPIn USB on every
               register already written, and the POS drives the two down different
               code paths — a native plugin versus an HTTP call to our backend. */
            creditMethod: 'credit_dejavoo_cloud',
        },
    },
    {
        /*
          THE SAME TERMINAL, RUNNING OUR APP.
    
          RubyTill Pay (applications/rubytill-pay-android) runs on the P-series
          terminal and drives DvPayLite through deep linking, so every screen but
          the card read is ours. The till reaches it through pos-pay-devices-service
          (our WebSocket relay), not SPIn. It pairs with a code shown in Super
          Admin — no Register Id or Auth Key — and carries the TPN so the terminal
          can download its card setup. Spec: docs/agenticpos-rubytill/rubytill-pay.md
        */
        id: 'dejavoo_rubytill_pay',
        label: 'Dejavoo P Series — RubyTill Pay',
        hint: 'Our own payment app on the terminal: our screens, tips and receipts. Pairs with a code from Super Admin; needs only the iPOS Transact TPN. The SPIn routes stay available.',
        orderUi: true,
        profile: {
            deviceClass: 'dejavoo_rubytill_pay',
            connectionType: 'cloud',
            /* Its own emvMode and tender: neither SPIn route's code path applies. */
            emvMode: 'rtpay',
            creditMethod: 'credit_dejavoo_rtpay',
        },
    },
    {
        /*
          MAGTEK DYNAFLEX II — PED or Go, over USB to the till (pos-magtek-service,
          UniGate). The catalog row is for stock and selling; a unit is REGISTERED
          from the register's Card readers (card setup), never the order rail — so
          orderUi is false.
        */
        id: 'magtek_usb',
        label: 'MagTek DynaFlex II — USB',
        hint: 'PED or Go, cabled to the till. Registered on the register’s Card readers; runs every sale as credit.',
        orderUi: false,
        profile: {
            deviceClass: 'magtek_usb',
            connectionType: 'usb',
            creditMethod: 'credit_magtek',
            emvMode: 'magtek',
        },
    },
    {
        /*
          SUNBAY PAYMENT ON A SUNMI CPAD PAY — Tapro runs on the CPad, the till hands
          it the amount (Taplink SDK, sub-screen over USB) and pos-sunbay-service
          verifies the result. A card reader, not part of any till: it is picked per
          register on Card readers, so orderUi is false like MagTek.
        */
        id: 'sunbay_tapro',
        label: 'SUNBAY Payment — SUNMI CPad Pay',
        hint: 'CPad Pay running SUNBAY Tapro, attached to the till. Registered on the register’s Card readers with its serial; RubyTill keeps tips, signature and receipts.',
        orderUi: false,
        profile: {
            deviceClass: 'sunbay_tapro',
            connectionType: 'usb',
            creditMethod: 'credit_sunbay',
            emvMode: 'sunbay',
        },
    },
    {
        id: 'dejavoo_cloud',
        label: 'Dejavoo Online (no terminal)',
        hint: 'Card-not-present, no physical pairing. The TPN and its iPOS Transact credentials are the whole identity.',
        orderUi: true,
        profile: {
            deviceClass: 'dejavoo_cloud',
            connectionType: 'cloud',
            creditMethod: 'credit_dejavoo',
            emvMode: 'cloud',
        },
    },
    {
        /*
          AN ANSWER, not the absence of one.
    
          A device nobody has configured yet is still a real device: it can be
          stocked, ordered, allocated and shipped. What it must NOT do is register
          a payment lane by guesswork. Picking this says so out loud, so
          registration can refuse with a sentence instead of defaulting to NMI.
        */
        id: 'none',
        label: 'No Payment Config (yet)',
        hint: 'Check the device into the catalog now and choose its lane later. It cannot register a payment lane until one is set.',
        orderUi: false,
    },
    {
        id: 'cloud',
        label: 'NMI Cloud',
        hint: 'Pairs with the code shown on the reader. Registered from the POS terminal screen.',
        legacy: true,
        orderUi: false,
        profile: {
            deviceClass: 'cloud',
            connectionType: 'cloud',
            creditMethod: 'credit_nmi_cloud',
            emvMode: 'cloud',
        },
    },
    {
        id: 'nmi_direct_vp3350',
        label: 'ID TECH VP3350 (NMI SDK)',
        hint: 'Pairs over Bluetooth or USB via the NMI Android SDK. Registered from the POS terminal screen.',
        legacy: true,
        orderUi: false,
        profile: {
            deviceClass: 'nmi_direct_vp3350',
            connectionType: 'bluetooth',
            creditMethod: 'credit_nmi_direct',
            emvMode: 'sdk',
        },
    },
];
/** The configs offered when adding a NEW payment device, in display order. */
exports.SELECTABLE_PAYMENT_CONFIGS = exports.PAYMENT_DEVICE_CONFIGS.filter((c) => !c.legacy);
/** The NMI ones — shown under "Legacy" so an existing row stays editable. */
exports.LEGACY_PAYMENT_CONFIGS = exports.PAYMENT_DEVICE_CONFIGS.filter((c) => c.legacy);
function getPaymentConfig(id) {
    if (!id)
        return undefined;
    return exports.PAYMENT_DEVICE_CONFIGS.find((c) => c.id === id);
}
/**
 * WHICH LANE THIS MODEL REGISTERS ON. The one place that is decided.
 *
 * Three sources, most deliberate first:
 *   1. `paymentConfigId` — somebody chose, and `none` is a choice.
 *   2. `paymentProfile.deviceClass` — seeded rows that predate the picker.
 *   3. the model NAME — the old exact-match, kept so nothing registered before
 *      today stops resolving. This is the fallback, never the rule.
 *
 * `undefined` means NOBODY WAS EVER ASKED, which is a different thing from the
 * `none` config and must be said differently: one is a row that predates the
 * picker, the other is a decision. Callers that collapse the two put us back
 * where we started.
 */
function resolvePaymentConfig(model) {
    if (!model)
        return undefined;
    return getPaymentConfig(model.paymentConfigId)
        || getPaymentConfig(model.paymentProfile?.deviceClass)
        || getPaymentConfig(getModelDef(model.modelName || undefined)?.deviceClass);
}
/**
 * THE CONFIGS THIS MODEL MAY BE REGISTERED AS, default first.
 *
 * A P17 can be wired to the till or reached over SPIn's cloud, and the choice
 * belongs to whoever has the terminal in hand — not to the catalog, which
 * cannot know which store a given unit ends up in. So the model declares what
 * it CAN be and registration records what it IS.
 *
 * `paymentConfigOptions` absent means "only the resolved config", which is
 * every catalog row written before this existed — they behave exactly as they
 * did, with no picker shown.
 *
 * `none` is filtered out wherever it appears: it means nobody has chosen a
 * lane, which is the absence of a choice rather than one of them.
 */
function paymentConfigOptionsFor(model) {
    const fallback = resolvePaymentConfig(model);
    const listed = (model?.paymentConfigOptions || [])
        .map((id) => getPaymentConfig(id))
        .filter((c) => !!c && c.id !== 'none');
    if (listed.length === 0) {
        return fallback && fallback.id !== 'none' ? [fallback] : [];
    }
    // Default first, then the rest in declared order, each appearing once.
    const ordered = [
        ...(fallback && listed.some((c) => c.id === fallback.id) ? [fallback] : []),
        ...listed.filter((c) => c.id !== fallback?.id),
    ];
    return ordered;
}
//# sourceMappingURL=emv-device-models.js.map